import React, { useState, useEffect }  from 'react';
import { DataGrid } from '@mui/x-data-grid';
import CodiceVSVoceCliccabile from '../CodiceVSVoceCliccabile';
import stileGrid from '../../interfaccia/stileGrid';

function ListaProdottiBrandDBperScheda(props) {
  const setProductFunction = props.setProductFunction
  const listaProdottiBrand = props.listaProdottiBrand;
  const utente = props.utente;
  //const tradPermessa = props.tradPermessa;
  //const codiceVSprodCorr = props.codiceVS;
  //const utente = props.utente;
  const [rows,setRows] = useState(
    listaProdottiBrand
  )

  useEffect(() => {
    setRows(listaProdottiBrand)
  },[listaProdottiBrand]);

  const columns = [
    {
      field: 'codiceVS',
      headerName: 'VS',
      width: 50,
      headerClassName: "b", // NON FUNZIONA, VIENE SOVRASCRITTO DA CLASSE .MuiDataGrid-columnHeaderTitle, MODIFICARE IN APP.CSS
      renderCell: (params) => {
        /* return <div className="rowitem">{params.row.codiceVS}</div>; */
        if (params.row.codiceVS) { return <CodiceVSVoceCliccabile codiceVS={params.row.codiceVS} setProductFunction={setProductFunction} utente={utente} /> } else { return <div className="rowitem">N/A</div> }
      }
    },
    {
      field: 'codiceProduttore',
      valueGetter: (params) => params.row.codiceProduttore?.codProduttoreIntero ?? "N/A",
      headerName: 'Cod Intero',
      headerClassName: 'b', // NON FUNZIONA, VIENE SOVRASCRITTO DA CLASSE .MuiDataGrid-columnHeaderTitle, MODIFICARE IN APP.CSS
      width: 175,
      renderCell: (params) => {
        if (params.row.codiceProduttore && params.row.codiceProduttore.codProduttoreIntero) { return <div className="rowitem">{params.row.codiceProduttore.codProduttoreIntero}</div>; } else { return <div className="rowitem">N/A</div> }
      }
    },
    {
      field: 'codiceProduttore.codProduttoreModello',
      valueGetter: (params) => params.row.codiceProduttore?.codProduttoreModello ?? "N/A",
      headerName: 'Cod Modello',
      headerClassName: 'fw7', // NON FUNZIONA, VIENE SOVRASCRITTO DA CLASSE .MuiDataGrid-columnHeaderTitle, MODIFICARE IN APP.CSS
      width: 150
    },
    {
      field: 'shortName',
      valueGetter: (params) => params.row.shortName?.it ?? "N/A",
      headerName: 'SHORTNAME IT',
      width: 200
    },
    {
      field: 'descrizioniSuPS',
      valueGetter: (params) => params.row.descrizioniSuPS?.titolo?.it ?? "N/A",

      headerName: 'Titolo',
      width: 300,
      renderCell: (params) => {
        if (params.row.descrizioniSuPS && params.row.descrizioniSuPS.titolo && params.row.descrizioniSuPS.titolo.it) { return <div className="rowitem">{params.row.descrizioniSuPS.titolo.it}</div>; } else { return <div className="rowitem">N/A</div> }
      }
    },
    {
      field: 'tradotto',
      valueGetter: (params) => params.row.tradotto.en.toString() ?? "false",

      headerName: 'TR',
      width: 50,
      renderCell: (params) => {
        if (params.row.tradotto && params.row.tradotto.en) { return <div className="rowitem">{params.row.tradotto.en.toString()}</div>; } else { return <div className="rowitem">false</div> }
      }
    },
    { field: 'esportato', headerName: 'EX', width: 50 },
    {
      field: 'lunghezzaDescLungaIta',
      valueGetter: (params) => params.row.lunghezzaDescLungaIta ?? "false",
      headerName: '#char desc',
      width: 100
    }
    /* {
      headerName: 'imposta brand',
      width: 300,
      renderCell: (params) => {
        return(<DatoModificabileInLinea idDocumento={params.row._id} dato="" nomeDato="brand" setProductFunction={setProductFunction} />)
      }
    } */
  ];

  return (
    <div
      className="colonnaTuttaPagina"
    >
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row._id}
        autoPageSize
        rowsPerPageOptions={[10, 20, 50]}
        pagination
        sx={stileGrid}
      />
    </div>
  )
}


export default ListaProdottiBrandDBperScheda;
